import React, { FC, MutableRefObject, ReactElement, ReactNode, useRef, useState } from 'react'
import { ReactState } from '../../Contexts'
import PopperBubble from '../PopperBubble'

type Props = {
    content: ReactElement
    children: ReactNode
    popoverPlacement?: 'top' | 'bottom' | 'left' | 'right'
}

export const HelpPopoverText: FC<Props> = ({ content, children, popoverPlacement }: Props): ReactElement => {
    const [isOpen, setIsOpen]: ReactState<boolean> = useState<boolean>(false)
    const triggerElement: MutableRefObject<null> = useRef<null>(null)

    return (
        <span className='help-popover'>
            <span
                className='help-popover-trigger-text'
                ref={triggerElement}
                onMouseOver={(): void => setIsOpen(true)}
                onMouseOut={(): void => setIsOpen(false)}
            >
                {children}
            </span>
            <PopperBubble
                className='help-popover-content'
                anchorEl={triggerElement.current}
                open={isOpen}
                content={content}
                placement={popoverPlacement ?? 'top'}
                infoMode
            />
        </span>
    )
}
